import { Link } from "react-router-dom";
import { liveFeed, topics } from "@/mocks/topics";

export default function LiveAndRanking() {
  const ranked = [...topics].sort((a, b) => b.heat - a.heat).slice(0, 5);
  const feedLoop = [...liveFeed, ...liveFeed];

  return (
    <section className="px-4 md:px-10 py-14 md:py-20 bg-background-100">
      <div className="grid grid-cols-1 lg:grid-cols-5 gap-8">
        <div className="lg:col-span-3">
          <div className="flex items-center gap-2 mb-5">
            <span className="w-8 h-8 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-live-line"></i>
            </span>
            <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950">实时讨论滚动</h2>
            <span className="ml-auto text-xs text-foreground-500 hidden sm:block">刚刚更新的网友发言</span>
          </div>

          <div className="relative h-[420px] overflow-hidden rounded-lg bg-background-50 border border-background-200/80">
            <div className="absolute inset-x-0 top-0 h-12 bg-gradient-to-b from-background-50 to-transparent z-10 pointer-events-none"></div>
            <div className="absolute inset-x-0 bottom-0 h-12 bg-gradient-to-t from-background-50 to-transparent z-10 pointer-events-none"></div>
            <ul className="animate-marquee-up">
              {feedLoop.map((item, idx) => (
                <li key={`${item.user}-${idx}`} className="flex items-start gap-3 px-4 md:px-6 py-4 border-b border-background-200/60">
                  <span className="w-9 h-9 shrink-0 flex items-center justify-center rounded-full bg-accent-100 text-accent-900 text-sm font-medium">
                    {item.user.slice(0, 1)}
                  </span>
                  <div className="min-w-0">
                    <div className="flex items-center gap-2 flex-wrap">
                      <span className="text-sm font-medium text-foreground-900">{item.user}</span>
                      <span className="text-[11px] px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-900">{item.topic}</span>
                    </div>
                    <p className="text-sm text-foreground-600 mt-1 leading-relaxed">{item.text}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="lg:col-span-2">
          <div className="flex items-center gap-2 mb-5">
            <span className="w-8 h-8 flex items-center justify-center rounded-md bg-accent-500 text-foreground-950">
              <i className="ri-fire-line"></i>
            </span>
            <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950">今日热度榜</h2>
          </div>
          <ol className="rounded-lg bg-background-50 border border-background-200/80 divide-y divide-background-200/70">
            {ranked.map((t, i) => (
              <li key={t.id}>
                <Link to={`/topic/${t.id}`} className="group flex items-start gap-3 p-4 cursor-pointer">
                  <span
                    className={`w-7 h-7 shrink-0 flex items-center justify-center rounded-md text-sm font-bold ${
                      i === 0 ? "bg-primary-500 text-background-50" : i < 3 ? "bg-primary-100 text-primary-700" : "bg-background-100 text-foreground-500"
                    }`}
                  >
                    {i + 1}
                  </span>
                  <div className="min-w-0">
                    <p className="text-sm text-foreground-900 leading-snug line-clamp-2 group-hover:text-primary-700 transition-colors">{t.title}</p>
                    <p className="text-xs text-foreground-500 mt-1.5 flex items-center gap-3">
                      <span className="flex items-center gap-1"><i className="ri-chat-3-line"></i>{t.commentCount} 讨论</span>
                      <span className="flex items-center gap-1"><i className="ri-fire-line text-primary-500"></i>{t.heat.toLocaleString()}</span>
                    </p>
                  </div>
                </Link>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}